import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './popular.css';
import Item from '../items/item';

const Popular = () => {
    const [popular, setPopular] = useState([]);
    
useEffect(() => {
    const predefinedProductIds = [
        '6638c6ea533c63ffd9199280',
        '6638cb3d533c63ffd919928f',
        '6638cb76533c63ffd9199292',
        '6638cdcfd561dcfb0ef8b832',
        '6638d111d561dcfb0ef8b84d'
    ];

    fetch(`${process.env.REACT_APP_URL}/api/products/all-products`)
        .then(response => response.json())
        .then(data => {
            const popularProducts = data.filter(item => item.orders > 0);

            if (popularProducts.length === 0) {
                const fallbackProducts = data.filter(item =>
                    predefinedProductIds.includes(item._id) // Ensure `_id` matches the backend
                );
                setPopular(fallbackProducts);
            } else {
                setPopular(popularProducts);
            }
        });
}, []);


    
    return (
        <div className='popular'>
            <div className='titles'>
                <div>
                    <h2>Popular Cards</h2>
                    <p>Our best-selling cards bought by bastards just like you.</p>
                </div>
                <div className='shop-all-button'>
                    <Link to='/all'><p>Shop all</p></Link>
                </div>
            </div>

            <div className="popular-item">
                {popular.map((item, i) => {
                    return <Item key={i} id={item.id} name={item.name} image={item.image} price={item.price} occasion={item.occasion} />
                })}
            </div>
        </div>
    );
}

export default Popular;
